import { Link } from "@tanstack/react-router";
import { Admonition } from "#/shared/components/admonition";

Many libraries implement the [Standard Schema](https://standardschema.dev) interface, which allows many other libraries to accept them without needing to specialise for each library.

```ts
import { personSchema } from "./schemas";

const person = await upfetch(url, { schema: personSchema });
```

We benchmark the time taken to parse using a standard schema.

<Admonition type="info">
  Some libraries require an adapter before they can be used as a standard schema. The time to
  convert the schema is not measured, only the time to parse using it.
</Admonition>
